export interface VatMessageKeyParams {
  vatLabel: 'VAT' | 'Tax' | string;
  isPriceInclVat?: boolean;
  shortFormat?: boolean;
}

export function getVatMessageKey({
  vatLabel,
  isPriceInclVat,
  shortFormat,
}: VatMessageKeyParams) {
  const baseVatKey = 'site.pricing.virtual-vat';
  const vatType = isPriceInclVat ? '.include' : '.exclude';
  const vatLabelName = ['VAT', 'Tax'].includes(vatLabel)
    ? `.${vatLabel.toLowerCase()}`
    : '.custom';
  const keyVariant = shortFormat && isPriceInclVat ? '.short' : '';

  return `${baseVatKey}${vatType}${vatLabelName}${keyVariant}`;
}
